module.exports = __webpack_public_path__ + "img/about_14.32c912f4.png";